export { default, useNavItems } from "./Footer";
